export default "__VITE_ASSET__Bu1NZy0X__"